const newItem = {
  data: {
    name: 'Untitled asset',
  },
  config: {},
};

const newContainer = {
  data: {
    name: 'New folder',
    children: [],
  },
  config: {
    collapsed: false,
  },
};

export default { newItem, newContainer };
